// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangeSecurityQuestionsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var ValidatableInput = Validator()(Input);
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var actions = require('./Izenda.ChangeSecurityQuestionsPopupActions');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var MyProfileAlert = require('../Toolbar/Izenda.MyProfileAlert');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  const { map } = require('lodash/fp');
  var SecurityQuestionAndAnswer = connect()(function(props) {
    var localization = props.localization;
    var question = props.question;
    var accountInfo = props.accountInfo;
    var index = props.index;
    var remainingQuestionList = accountInfo.getRemainingQuestionList(question);

    return (
      <GridLayout className='u_paddingTop'>
        <GridLayout.Row>
          <GridLayout.Col cols='4'>
            <label className='validation required u_controlHeight control-label'>
              {localization.getText('COMMON_LABEL_SECURITY_QUESTION')} {index}
            </label>
          </GridLayout.Col>
          <GridLayout.Col cols='8'>
            <DropDown
              options={remainingQuestionList}
              labelField='question'
              valueField='securityQuestionId'
              value={question.securityQuestionId}
              onChange={notifyChange(
                question.updateProperty.bind(question, 'securityQuestionId'),
                EventsUtils.DROPDOWN
              )}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='4'>
            <label className='validation required u_controlHeight control-label'>
              {localization.getText('COMMON_LABEL_YOUR_ANSWER')}
            </label>
          </GridLayout.Col>
          <GridLayout.Col cols='8'>
            <ValidatableInput
              field='yourAnswer'
              className='form-control'
              value={question.answer}
              validations={AccountConstants.CONSTRAINTS.yourAnswer}
              onChange={notifyChange(question.updateProperty.bind(question, 'answer'), EventsUtils.INPUT)}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  });

  var ChangeSecurityQuestionsPopup = React.createClass({
    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentWillMount: function() {
      this.props.store.model.getSelectedQuestionList();
    },

    renderSecurityQuestionAndAnswer: function() {
      var index = 1;
      return map(
        function(question) {
          return (
            <SecurityQuestionAndAnswer
              key={question.securityQuestionId}
              accountInfo={this.props.store.model}
              question={question}
              index={index++}
            />
          );
        }.bind(this),
        this.props.store.model.selectedQuestionList
      );
    },

    /**
     * Render component
     */
    render: function() {
      var localization = this.props.localization;

      return (
        <Popup visible onClosing={this.props.onClosing} autoClose={false} type='none' sizeClass='modal-xs-responsive'>
          <Popup.Header title={localization.getText('COMMON_LABEL_CHANGE_SECURITY_QUESTION')} />
          <Popup.Body>
            <MyProfileAlert alertMessage={this.props.store.model.alertMessage} />
            {this.renderSecurityQuestionAndAnswer()}
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>
              {localization.getText('COMMON_LABEL_SAVE')}
            </Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect(actions)(ChangeSecurityQuestionsPopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/SecurityOptions/Izenda.ChangeSecurityQuestionsPopup.jsx